import { ResourceTypeDtoMetaTypeEnum } from '@jooxter/api';
import { JxtAlertTypeEnum } from '@jooxter/ui';
import { Duration } from 'luxon';
import { getRemainingTime } from './getRemainingTime';
import { IGetDailyQuotaParams } from './types';

export const getDailyQuota = ({
  resourceType,
  dailyQuota,
  remainingTime,
  language,
}: IGetDailyQuotaParams): { type: JxtAlertTypeEnum; formattedRemainingTime?: string } | null => {
  if (resourceType === ResourceTypeDtoMetaTypeEnum.Vehicle || remainingTime === undefined || !dailyQuota) {
    return null;
  }

  const formattedRemainingTime = getRemainingTime(remainingTime, language);
  const remainingTimeInSeconds = remainingTime === null ? 0 : Number.parseInt(remainingTime, 10);
  const dailyQuotaDuration = Duration.fromISO(dailyQuota);

  if (!dailyQuotaDuration.isValid) {
    return null;
  }

  const dailyQuotaInSeconds = dailyQuotaDuration.as('seconds');

  let type: JxtAlertTypeEnum;

  if (remainingTimeInSeconds === 0) {
    type = JxtAlertTypeEnum.Error;
  } else if (remainingTimeInSeconds === dailyQuotaInSeconds) {
    type = JxtAlertTypeEnum.Success;
  } else {
    type = JxtAlertTypeEnum.Warning;
  }

  return {
    type,
    formattedRemainingTime: formattedRemainingTime.formatted,
  };
};
